import { render } from "./FooterCopyright.vue?vue&type=template&id=ffab0fda"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__